import { useState, useRef } from 'react';

const branches = [
  {
    id: 'seomyeon',
    name: '서면지점',
    address: '부산광역시 부산진구 신천대로62번길 67',
    subway: '1·2호선 서면역 1번 출구 도보 3분',
    parking: '건물 내 전용 주차장 운영 (무료)',
    hours: '매일 24시 대기 (연중무휴)',
    phone: '010-5781-5340',
    kakao: '카카오 ID: busanhost',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.5!2d129.0590!3d35.1579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3568eba5b5b5b5b5%3A0x0!2z7ISc7Jq47Yq567mM7IKw!5e0!3m2!1sko!2skr!4v1700000000001',
    kakaoMapUrl: 'https://map.kakao.com/?q=%EB%B6%80%EC%82%B0+%EC%A7%84%EA%B5%AC+%EC%8B%A0%EC%B2%9C%EB%8C%80%EB%A1%9C62%EB%B2%88%EA%B8%B8+67',
  },
  {
    id: 'haeundae',
    name: '해운대지점',
    address: '부산광역시 해운대구 구남로 37',
    subway: '2호선 해운대역 3번 출구 도보 5분',
    parking: '건물 내 전용 주차장 운영 (무료)',
    hours: '매일 24시 대기 (연중무휴)',
    phone: '010-5781-5340',
    kakao: '카카오 ID: busanhost',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.0!2d129.1603!3d35.1588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3568eba5b5b5b5b5%3A0x0!2z7ZWc7Jq47Yq567mM7IKw!5e0!3m2!1sko!2skr!4v1700000000002',
    kakaoMapUrl: 'https://map.kakao.com/?q=%EB%B6%80%EC%82%B0+%ED%95%B4%EC%9A%B4%EB%8C%80%EA%B5%AC+%EA%B5%AC%EB%82%A8%EB%A1%9C+37',
  },
  {
    id: 'gwangalli',
    name: '광안리지점',
    address: '부산광역시 수영구 광안해변로 197',
    subway: '2호선 광안역 3번 출구 도보 7분',
    parking: '인근 공영주차장 이용 (유료)',
    hours: '매일 24시 대기 (연중무휴)',
    phone: '010-5781-5340',
    kakao: '카카오 ID: busanhost',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.8!2d129.1185!3d35.1530!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3568eba5b5b5b5b5%3A0x0!2z6rWQ7JqU66GcIOyImOyKpA!5e0!3m2!1sko!2skr!4v1700000000003',
    kakaoMapUrl: 'https://map.kakao.com/?q=%EB%B6%80%EC%82%B0+%EC%88%98%EC%98%81%EA%B5%AC+%EA%B4%91%EC%95%88%ED%95%B4%EB%B3%80%EB%A1%9C+197',
  },
  {
    id: 'yeonsan',
    name: '연산지점',
    address: '부산광역시 연제구 반송로 32-8',
    subway: '1·3호선 연산역 5번 출구 도보 4분',
    parking: '건물 내 전용 주차장 운영 (무료)',
    hours: '매일 24시 대기 (연중무휴)',
    phone: '010-5781-5340',
    kakao: '카카오 ID: busanhost',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.3!2d129.0820!3d35.1860!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3568eba5b5b5b5b5%3A0x0!2z7Jew7IKw64-Z!5e0!3m2!1sko!2skr!4v1700000000004',
    kakaoMapUrl: 'https://map.kakao.com/?q=%EB%B6%80%EC%82%B0+%EC%97%B0%EC%A0%9C%EA%B5%AC+%EB%B0%98%EC%86%A1%EB%A1%9C+32-8',
  },
];

const infoConfig = [
  { icon: 'ri-map-pin-2-fill', label: '주소', key: 'address', color: '#ec4899' },
  { icon: 'ri-car-line', label: '주차', key: 'parking', color: '#a855f7' },
  { icon: 'ri-time-line', label: '운영시간', key: 'hours', color: '#ec4899' },
  { icon: 'ri-phone-fill', label: '전화 예약', key: 'phone', color: '#06b6d4' },
  { icon: 'ri-kakao-talk-fill', label: '카카오톡', key: 'kakao', color: '#a855f7' },
];

export default function Location() {
  const [activeId, setActiveId] = useState('seomyeon');
  const scrollRef = useRef<HTMLDivElement>(null);
  const branch = branches.find(b => b.id === activeId)!;

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'left' ? -160 : 160, behavior: 'smooth' });
    }
  };

  return (
    <section id="location" className="py-20 md:py-32 bg-black relative overflow-hidden">
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] pointer-events-none opacity-5"
        style={{ background: 'radial-gradient(circle, #ec4899 0%, transparent 70%)', filter: 'blur(80px)' }}
      />
      <div
        className="absolute bottom-0 right-0 w-[400px] h-[400px] pointer-events-none opacity-5"
        style={{ background: 'radial-gradient(circle, #06b6d4 0%, transparent 70%)', filter: 'blur(80px)' }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        {/* 헤더 */}
        <div className="text-center mb-10 md:mb-12">
          <div
            className="inline-block px-6 py-2 rounded-full mb-6 md:mb-8 border"
            style={{ borderColor: '#ec4899', boxShadow: '0 0 12px rgba(236,72,153,0.3)' }}
          >
            <span className="text-sm font-medium tracking-wider" style={{ color: '#ec4899', textShadow: '0 0 8px #ec4899' }}>
              LOCATION
            </span>
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold mb-4 leading-tight"
            style={{ fontFamily: "'Orbitron', sans-serif", color: '#fff', textShadow: '0 0 15px rgba(255,255,255,0.2)' }}
          >
            오시는 <span style={{ color: '#ec4899', textShadow: '0 0 15px #ec4899' }}>길</span>
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            부산 전역 4개 지점에서 만나보세요.<br />
            편리한 교통과 전용 주차장으로 쉽게 찾아오실 수 있습니다.
          </p>
        </div>

        <div
          className="w-full h-px mb-8 md:mb-10"
          style={{ background: 'linear-gradient(90deg, transparent, #ec4899, #06b6d4, transparent)' }}
        />

        {/* 지점 탭 - 좌우 화살표 + 가로 스크롤 */}
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          {/* 왼쪽 화살표 */}
          <button
            onClick={() => scroll('left')}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:border-pink-500 hover:text-pink-500 transition-all cursor-pointer"
            style={{ background: 'rgba(255,255,255,0.04)' }}
            aria-label="이전 지점"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-s-line text-base" />
            </div>
          </button>

          {/* 스크롤 탭 영역 */}
          <div
            ref={scrollRef}
            className="flex items-center gap-2 md:gap-3 overflow-x-auto flex-1"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {branches.map(b => (
              <button
                key={b.id}
                onClick={() => setActiveId(b.id)}
                className="px-5 md:px-7 py-2.5 rounded-full text-sm font-semibold tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0"
                style={
                  activeId === b.id
                    ? { background: 'linear-gradient(135deg, #ec4899, #f97316)', color: '#000', boxShadow: '0 0 20px rgba(236,72,153,0.6)' }
                    : { background: 'rgba(255,255,255,0.04)', color: '#9ca3af', border: '1px solid #374151' }
                }
                onMouseEnter={e => {
                  if (activeId !== b.id) {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#ec4899';
                    (e.currentTarget as HTMLButtonElement).style.color = '#ec4899';
                    (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 0 10px rgba(236,72,153,0.3)';
                  }
                }}
                onMouseLeave={e => {
                  if (activeId !== b.id) {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#374151';
                    (e.currentTarget as HTMLButtonElement).style.color = '#9ca3af';
                    (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
                  }
                }}
              >
                {b.name}
              </button>
            ))}
          </div>

          {/* 오른쪽 화살표 */}
          <button
            onClick={() => scroll('right')}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:border-pink-500 hover:text-pink-500 transition-all cursor-pointer"
            style={{ background: 'rgba(255,255,255,0.04)' }}
            aria-label="다음 지점"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-base" />
            </div>
          </button>
        </div>

        {/* 지점 이름 */}
        <div className="text-center mb-6 md:mb-8">
          <span
            className="text-base md:text-xl font-bold tracking-widest"
            style={{ fontFamily: "'Orbitron', sans-serif", color: '#ec4899', textShadow: '0 0 12px #ec4899' }}
          >
            BUSANHOST — {branch.name.toUpperCase()}
          </span>
        </div>

        {/* 지도 + 정보 - 모바일에서 1열 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-start">
          {/* 지도 */}
          <div
            className="rounded-2xl overflow-hidden border border-gray-800 relative"
            style={{ boxShadow: '0 0 30px rgba(236,72,153,0.15)' }}
          >
            <div
              className="absolute inset-0 pointer-events-none z-10 rounded-2xl"
              style={{ boxShadow: 'inset 0 0 30px rgba(236,72,153,0.1)' }}
            />
            <iframe
              key={branch.id}
              title={`${branch.name} 위치`}
              src={branch.mapSrc}
              width="100%"
              height="300"
              className="md:h-[420px]"
              style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg) saturate(0.8) brightness(0.85)', display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* 정보 카드 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {infoConfig.map((item, index) => {
              const value = branch[item.key as keyof typeof branch] as string;
              return (
                <div
                  key={index}
                  className="p-4 md:p-5 rounded-xl border border-gray-800 relative overflow-hidden cursor-default"
                  style={{ background: 'rgba(255,255,255,0.02)', transition: 'box-shadow 0.3s, border-color 0.3s' }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLDivElement).style.boxShadow = `0 0 20px ${item.color}33`;
                    (e.currentTarget as HTMLDivElement).style.borderColor = item.color;
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
                    (e.currentTarget as HTMLDivElement).style.borderColor = '#1f2937';
                  }}
                >
                  <div className="flex items-center gap-3 mb-2 md:mb-3">
                    <div
                      className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg flex-shrink-0"
                      style={{ background: `${item.color}18`, border: `1px solid ${item.color}44` }}
                    >
                      <i className={`${item.icon} text-base md:text-lg`} style={{ color: item.color, textShadow: `0 0 10px ${item.color}` }} />
                    </div>
                    <span className="text-xs font-semibold tracking-wider uppercase" style={{ color: item.color, textShadow: `0 0 8px ${item.color}` }}>
                      {item.label}
                    </span>
                  </div>
                  <p className="text-gray-300 text-xs md:text-sm leading-relaxed">{value}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* 하단 CTA */}
        <div className="mt-10 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={branch.kakaoMapUrl}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-black transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
            style={{ background: 'linear-gradient(135deg, #ec4899, #f97316)', boxShadow: '0 0 25px rgba(236,72,153,0.5)' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-2-fill text-base" />
            </div>
            카카오맵 길찾기
          </a>
          <a
            href={`https://map.naver.com/v5/search/${encodeURIComponent(branch.address)}`}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm md:text-base border border-gray-700 text-gray-300 hover:border-green-500 hover:text-green-400"
            style={{ background: 'rgba(255,255,255,0.03)' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-2-line text-base" />
            </div>
            네이버지도 길찾기
          </a>
          <a
            href={`https://maps.google.com/maps?q=${encodeURIComponent(branch.address)}`}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm md:text-base border border-gray-700 text-gray-300 hover:border-red-400 hover:text-red-300"
            style={{ background: 'rgba(255,255,255,0.03)' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-global-line text-base" />
            </div>
            구글맵 길찾기
          </a>
        </div>
      </div>
    </section>
  );
}
